module.exports = __webpack_public_path__ + "img/0Q3B3793_L_Wood.543c85b5.jpg";